'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.totop = twentyninetimes.totop || function () {

    function init() {
        scrollToTop();
    }

    function scrollToTop() {
        // Create a scroll to top of page on button click with class .js-to-top
        var toTop = document.querySelector('.js-to-top');
        if (toTop) {
            toTop.addEventListener('click', function () {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }
    }

    return {
        init: init
    };

}();